import { Component, ReactNode } from 'react';
import "../../organisms/AiMcatChat/index.scss";

interface ErrorBoundaryProps {
    children: ReactNode;
    fallback?: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class MarkdownErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        console.error('Markdown rendering failed:', error);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || <span className="markdown-fallback-error">⚠️ Failed to render message.</span>;
        }
        return this.props.children;
    }
}

export default MarkdownErrorBoundary;